module.exports = __webpack_public_path__ + "img/国电周榜_画板 1.9af831b5.png";